import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'w-full bg-white py-2',
    carousel:
      'w-full [--slide-size:auto] [--slide-spacing:16px] md:[--slide-spacing:4px]',
    viewport:
      'px-[calc(50%-var(--screen-max-width)/2+var(--spacing)*4)] max-2xl:px-4 max-sm:px-3',
    controls: 'pointer-events-none absolute inset-0 max-sm:hidden',
    controlsContainer: 'container h-full',
    controlsInner: 'relative h-full',
    controlsButton: 'top-1',
    resetButton: 'h-full px-0! md:mr-3',
    resetButtonIcon: 'mt-[1px] ml-1 size-5.5'
  }
});
